import React from 'react';
import useDataGrid from '@afosto/utils-react/datagrid/useDataGrid';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import DataGrid from '@afosto/app-components-react/DataGrid';
import dataSourceRequest from '@afosto/utils-react/dataSource/dataSourceRequest';
import { subscription as subscriptionApi } from '@afosto/iam/api/Subscription';
import { actionsFormatter, totalFormatter, invoiceInfoFormatter } from './formatters';
import translations from './translations';

const fetchInvoices = async dataSource =>
  dataSourceRequest(
    dataSource,
    async (data, requestOptions) => subscriptionApi.listSubscriptionInvoices(requestOptions),
    { transformData: data => data },
  );

const InvoicesOverview = () => {
  const [hasPermissions, UnauthorizedComponent] = usePermissions(['iam:subscriptions:read']);
  const intl = useIntl();

  const dataSource = useDataGrid(fetchInvoices, {
    modules: ['dataProperties', 'pagination'],
    pagination: {
      itemsPerPage: 10,
    },
    dataProperties: {
      fixedProperties: [
        {
          key: 'reference',
          name: intl.formatMessage({
            id: 'dataGrid.columns.invoices.invoice',
            defaultMessage: 'Invoice',
            description: 'The column name for column invoice',
          }),
          type: 'invoiceInfo',
          width: '99%',
        },
        {
          key: 'total',
          name: intl.formatMessage({
            id: 'dataGrid.columns.invoices.total',
            defaultMessage: 'Total',
            description: 'The column name for column total',
          }),
          type: 'total',
          align: 'right',
        },
        {
          key: 'paymentUrl',
          name: intl.formatMessage({
            id: 'dataGrid.columns.invoices.actions',
            defaultMessage: 'Actions',
            description: 'The column name for column actions',
          }),
          type: 'actions',
        },
      ],
    },
  });

  if (!hasPermissions()) {
    return (
      <Card>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
        />
        <CardContent>
          <UnauthorizedComponent showActions={false} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <DataGrid
          size="small"
          dataSource={dataSource}
          formatters={{
            actions: actionsFormatter,
            total: totalFormatter,
            invoiceInfo: invoiceInfoFormatter,
          }}
        />
      </CardContent>
    </Card>
  );
};

export default InvoicesOverview;
